import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {ReservationDriver} from "types/entities/ReservationDriver";
import {clsx} from "clsx";
import {UpsellOption} from "types/entities/specific/UpsellOption";
import {useAssignedItems} from "utils/hooks/useAssignedItems";
import {toast} from "react-toastify";
import {AddUpsellItem} from "pages/Front/Booking/BookingLogin/components/ReservationDetailComponents/AddUpsellItem";
import FeatherIcon from "components/FeatherIcon";

interface AccessTicketDriverUpsellProps {
    driver: ReservationDriver;
    option: UpsellOption;
    package_item_id: number;
    count: number;
    used_count: number;
}

const AccessTicketDriverUpsellBase = (props: AccessTicketDriverUpsellProps) => {
    const {t} = useTranslation();
    const {usedUpsellItems, manageItemHandler, reservationDriverUpsellItems, setAllItems} = useAssignedItems(props.driver);

    const addSelectedItemHandler = (item: UpsellOption) => {
        if (!item || !item.freeValues || item.freeValues.length == 0) {
            console.log(item);
            toast.error("Error");
            return;
        }
        manageItemHandler(item.freeValues[0], "add").then(
            r => {
                setAllItems();
                console.log(usedUpsellItems(item.package_item_id));
            },
            reject => {}
        );
    };

    const removeSelectedItemHandler = (item: UpsellOption) => {
        console.log(item);
        const usedItems = usedUpsellItems(item.package_item_id);
        console.log(usedItems, reservationDriverUpsellItems);
        if (!usedItems || usedItems.length == 0) {
            toast.error("Error");
            return;
        }

        manageItemHandler(usedItems[usedItems.length - 1].id, "remove").then(
            r => {
                console.log("manageItemHandler - remove", usedItems[usedItems.length - 1].id, "success");
                setAllItems();
                console.log(usedUpsellItems(item.package_item_id));
            },
            reject => {
                console.log(reject);
            }
        );
    };

    useEffect(() => {
        setAllItems();
    }, [props.driver, props.count, props.used_count]);

    return (
        // <div className={"AccessTicketDriverUpsell rounded-[10px] transform-gpu  bg-white text-xs md:text-base  leading-[1] text-black shadow-card"}>
        <div className={"AccessTicketDriverUpsell rounded-[10px] transform-gpu bg-white text-xs md:text-base text-black shadow-card"}>
            {/*<div className={"flex items-center justify-between py-1 md:py-2 md:pr-2 pr-1 overflow-hidden"}>*/}
            <div className={"flex items-center justify-between overflow-hidden"}>
                {/*<div className={clsx("size-5 md:size-8 shrink-0 box-content p-3")}>*/}
                <div className={clsx("box-content py-[20px] md:py-[30px] pl-[11px] md:pl-[16px] pr-[13px] md:pr-[24px] stroke-2 flex items-center justify-center")}>
                    <FeatherIcon className={"size-[20px] md:size-[30px] text-arbo-yellow"} name={"shopping-bag"} strokeWidth={2} />
                </div>

                {/*<div className="flex flex-col sm:flex-row items-start sm:items-center justify-start grow font-medium text-left gap-1 sm:gap-2">*/}
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-start grow font-medium text-left gap-x-1 sm:gap-x-2">
                    {/*<span className={clsx("font-medium")}>{props.option.label}</span>*/}
                    <span className={clsx("leading-normal font-medium")}>{props.option.label}</span>
                    <div className={"text-xs md:text-base font-light text-black"}>
                        {t("Available")}:&nbsp;{props.count}
                    </div>
                </div>
                <AddUpsellItem
                    optionId={props.package_item_id}
                    available={props.count}
                    usedCount={props.used_count}
                    onAdd={() => addSelectedItemHandler(props.option)}
                    onRemove={() => removeSelectedItemHandler(props.option)}
                />
            </div>
        </div>
    );
};

// re-render iba keď sa zmení to, čo sa naozaj zobrazuje
const propsAreEqual = (prev: AccessTicketDriverUpsellProps, next: AccessTicketDriverUpsellProps) =>
    prev.count === next.count && prev.used_count === next.used_count && prev.package_item_id === next.package_item_id;

const AccessTicketDriverUpsell = React.memo(AccessTicketDriverUpsellBase, propsAreEqual);
export default AccessTicketDriverUpsell;
